var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndicatorCloseToExpiring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24949_55679)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 12.5,
    r: 2.5,
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.45459 7.27273C1.45459 3.27273 4.72732 0 8.72732 0C12.7273 0 16 3.27273 16 7.27273C16 11.2727 12.7273 14.5455 8.72732 14.5455C8.56528 14.5455 8.40443 14.5401 8.24494 14.5295C8.45574 14.0818 8.60321 13.5983 8.67579 13.0907C8.69295 13.0908 8.71013 13.0909 8.72732 13.0909C11.9346 13.0909 14.5455 10.48 14.5455 7.27273C14.5455 4.06545 11.9346 1.45455 8.72732 1.45455C5.52004 1.45455 2.90914 4.06545 2.90914 7.27273C2.90914 7.28992 2.90921 7.30709 2.90936 7.32425C2.40175 7.39684 1.91829 7.5443 1.47053 7.7551C1.45996 7.59562 1.45459 7.43477 1.45459 7.27273ZM8.00004 3.63636H9.09095V7.41818L12.3637 9.38182L11.7819 10.3273L8.00004 8V3.63636Z",
    fill: "#364863"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9C1.568 9 0 10.568 0 12.5C0 14.432 1.568 16 3.5 16C5.432 16 7 14.432 7 12.5C7 10.568 5.432 9 3.5 9ZM3.85 14.6H3.15V13.9H3.85V14.6ZM3.85 13.2H3.15V10.4H3.85V13.2Z",
    fill: "#FF7F16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24949_55679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicatorCloseToExpiring);
export default __webpack_public_path__ + "static/media/icon-indicator-close-to-expiring.41cbdd45f688d4d1f959949a65c48419.svg";
export { ForwardRef as ReactComponent };